export const adjustDriversData = driver => {
  const { userId: user } = driver;
  return {
    id: driver && driver.profileId,
    name: user && user.name,
    lastname: user && user.lastname,
    patronymic: user && user.patronymic,
    photo: user && user.photo,
  };
};
